<template>
    <div class="section-box">
        <el-tabs v-model="form.levelType" type="card" class="customer-tabs-mg" @tab-click="handleSearch()">
            <el-tab-pane v-for="(item, index) in tabList" :label="item.value" :name="item.key + ''" :key="index">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list-product">
            <div class="next-button">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="openLevel()">新增</el-button>
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>
        <!-- eslint-disable  -->
        <el-table
                ref='table'
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                height="670"
                border
                v-loading="listLoading"
                :key="toggleIndex"
        >
            <el-table-column label="顺序">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" oninput="if(value.length>10)value=value.slice(0,10)"  type="number" v-model="form.sortNo" placeholder="请输入编号搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.sortNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属领域">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.productDomainName" placeholder="请输入领域名称搜索" maxlength="100"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.productDomainName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="一级产品名称" v-if="form.levelType==1||form.levelType==2||form.levelType==3">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.firstProductName" placeholder="请输入一级产品名称搜索" maxlength="100"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.firstProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="二级产品名称" v-if="form.levelType==2||form.levelType==3">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.secondProductName" placeholder="请输入二级产品名称搜索" maxlength="100"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.secondProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="三级产品名称" v-if="form.levelType==3">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.thirdProductName" placeholder="请输入三级产品名称搜索" maxlength="100"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.thirdProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="备注">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.description" placeholder="请输入备注搜索" maxlength="1000"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.description || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="状态">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select v-model.trim="form.status" placeholder="请选择" size="mini">
                            <el-option
                                v-for="(item, index) in options"
                                :key="index"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                     </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.status">有效</span>
                        <span v-else>无效</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" fixed="right"  width="300">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="form.levelType!=0" :disabled="!scope.row.status" @click="openmodfMod(scope.row)">修改</el-button>
                    <el-button size="mini" type="primary" v-if="!scope.row.status" @click="recovery(scope.row)">恢复</el-button>
                    <el-button size="mini" type="warning" v-if="scope.row.status" @click="openZFModl(scope.row)">作废</el-button>
                    <el-button size="mini" type="primary" :disabled="!scope.row.status" @click="openAjust(scope.row)">调整顺序</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="form.pageNum"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="form.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <add-field
           ref="addFiled"
           v-if="showFiled"
           @close="closeFiled"
           @refreshList="successLibrary"
       ></add-field>
        <add-level
            ref="addLevel"
            v-if="showLevel"
            :current-param="currentlevelParam"
            @close="closeLevel"
            @refreshList="successLibrary"
       >
       </add-level>
        <el-dialog
                title="作废操作"
                :visible="showZFModel"
                :close-on-click-modal="!showZFModel"
                :before-close="closeZFModel"
                width="500px"
        >
          <div class="pad-20">
              <h3>您正在执行作废操作，一旦确认，【{{zfname}}】及下属产品和服务将全部作废，请谨慎操作</h3>
              <div class="dialog-footer" style="text-align: center;margin-top: 40px;" slot="footer">
                  <el-button type="primary" @click="confirmZF">确认作废</el-button>
              </div>
          </div>
        </el-dialog>
        <el-dialog
                title="调整顺序"
                :visible="showAdjustModel"
                :close-on-click-modal="!showAdjustModel"
                :before-close="closeTZModel"
                width="450px"
        >
            <div class="pad-20">
                <h3>【{{tzdata.tzname}}】当前的顺序为{{tzdata.tzid}}，最大有效条目的顺序是{{tzdata.maxSort}}，请输入需要调整至的顺序：</h3>
                <el-form ref="form" :model="TZModel" label-width="0px" :rules="rules" class="m-t-20">
                    <el-form-item label="" prop="sortNo">
                        <el-input type="number" v-model.trim="TZModel.sortNo" maxlength="100" placeholder="请输入顺序"  clearable style="width: 380px"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer" style="text-align: center;margin-top: 40px;" slot="footer">
                    <el-button type="primary" @click="confirmTZ">确认调整</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import addField from './index/addField';
    import addLevel from './index/addLevel';
    import { productList,updateStatus,getSortNo,updateSortNo} from "@/service/dataFrame";
    import { getStorageUserRoleId,getActionData } from '@/utils/store'
    export default {
        name: "productLibrary",
        components:{ addField,addLevel},
        data(){
            return{
                showFiled:false,//领域弹窗,
                showLevel:false,//新增一二三级
                currentFieldParam:{},
                currentlevelParam:{
                    // levelType:1
                },
                showZFModel:false,//作废
                showAdjustModel:false,//调整顺序
                TZModel:{
                    sortNo:''
                },
                rules:{
                    sortNo: [{required:true, message: '请输入顺序！', trigger: 'blur'}],
                },
                tabList:[
                    // {key:0,value:'领域'},
                    {key:1,value:'一级产品'},
                    {key:2,value:'二级产品'},
                    {key:3,value:'三级产品'}
                ],
                options: [
                    {value: "",label: '全部'},
                    {value: true,label: '有效'},
                    {value: false,label: '无效'}
                ],
                options2: [
                    {value:'a',label: '全部'},
                    {value:'b',label: '有效'},
                    {value:'c',label: '无效'}
                ],
                listLoading:false,
                tableData: [],
                form:{
                    levelType:'3',
                    sortNo:'',
                    productDomainName:'',
                    firstProductName:'',
                    secondProductName:'',
                    thirdProductName:'',
                    description:'',
                    status: '',
                    pageNum: 1,
                    pageSize: 10
                },
                total: 0,
                oraginForm:{},
                searchData:{},
                toggleIndex:0,
                zfdata:{},
                zfname:'',
                tzdata:{
                    id:0,
                    tzid:0,
                    tzname:'',
                    maxSort:0
                }
            }
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch();
        },
        methods:{
            successLibrary(){
                this.getProlist();
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val;
                this.searchData.pageNum = 1
                this.searchData.pageSize = val;
                this.getProlist();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val;
                this.searchData.pageNum = val;
                this.getProlist();
            },
            handleSearch(){
                this.searchData = Object.assign({}, this.form)
                this.form.pageNum = 1;
                this.searchData.pageNum = 1;
                this.getProlist();
            },
            async getProlist(){
                this.listLoading = true;
                this.toggleIndex=this.form.levelType;
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.id && delete data.id
                !data.productDomainName && delete data.productDomainName
                !data.firstProductName && delete data.firstProductName
                !data.secondProductName && delete data.secondProductName
                !data.thirdProductName && delete data.thirdProductName
                !data.description && delete data.description
                let res = await productList(data)
                this.listLoading = false
                // console.log("res",res)
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.tableData = res.Data.datas || [];
                this.total = res.Data.total;
                this.$nextTick(() => {
                    this.$refs.table.doLayout()
                })
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            closeFiled(){
                this.showFiled=false;
            },
            openLevel(){
                if (this.form.levelType==0){
                    this.showFiled=true;
                }else {
                    this.currentlevelParam={
                        levelType:this.form.levelType,
                        update:-1
                    }
                    this.showLevel=true;
                }

            },
            closeLevel(){
               this.showLevel=false;
            },
            closeZFModel(){
                this.showZFModel=false;
            },
            closeTZModel(){
                this.showAdjustModel=false;
            },
            openZFModl(data){
               this.showZFModel=true;
               let param={
                   id:data.id,
                   levelType:this.form.levelType,
                   status:!data.status,
                   userId:getStorageUserRoleId(),
               }
               this.zfdata=param;
                if(this.form.levelType==1){
                    this.zfname=data.firstProductName;

                }else if(this.form.levelType==2){
                    this.zfname=data.secondProductName;
                }else if(this.form.levelType==3){
                    this.zfname=data.thirdProductName;
                }else{
                    this.zfname=data.productDomainName;
                }
               // this.zfname=data.productDomainName
               // console.log("zfdata",this.zfdata)
            },
            recovery(data){
                let param={
                    id:data.id,
                    levelType:this.form.levelType,
                    status:!data.status,
                    userId:getStorageUserRoleId(),
                }
                updateStatus(param).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success("操作成功")
                    this.getProlist();
                })
            },
            confirmZF(){
                updateStatus(this.zfdata).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.showZFModel=false;
                    this.$message.success("操作成功")
                    this.getProlist();
                })
                // console.log("作废")
            },
            openAjust(data){
                this.TZModel.sortNo='';
                if(this.form.levelType==1){
                    this.tzdata.tzname=data.firstProductName;

                }else if(this.form.levelType==2){
                    this.tzdata.tzname=data.secondProductName;
                }else if(this.form.levelType==3){
                    this.tzdata.tzname=data.thirdProductName;
                }else{
                    this.tzdata.tzname=data.productDomainName;
                }
                this.tzdata.tzid=data.sortNo;
                this.tzdata.id = data.id;
                let param={
                    levelType:this.form.levelType
                }
                getSortNo(param).then(res=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.tzdata.maxSort=res.Data;
                })
                this.showAdjustModel=true;
            },
            confirmTZ(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let param={
                            id:this.tzdata.id,
                            levelType:this.form.levelType,
                            sortNo:this.TZModel.sortNo,
                            userId:getStorageUserRoleId()
                        }
                        updateSortNo(param).then(res=>{
                            if(res.Result != 1) {
                                return this.$message.error(res.Message)
                            }
                            this.$message.success("操作成功");
                            this.showAdjustModel=false;
                            this.handleCurrentChange(1);
                        })
                    }
                })

            },
            openmodfMod(data){
                this.currentlevelParam=data;
                this.currentlevelParam.levelType=this.form.levelType;
                this.currentlevelParam.update=1;
                // console.log("修改",this.currentlevelParam)
                this.showLevel=true;
            }
        }
    }
</script>

<style lang="scss">
    .section-box {
        .pad-20 {
            padding: 10px 20px;
        }

        .m-t-20 {
            margin-top: 20px;
        }

        .customer-list-product {
            position: relative;

            .next-button {
                position: absolute;
                right: 0;
                top: -56px;
            }
        }
        .el-table th.gutter {
            display: table-cell !important;
        }
    }

</style>
